import { render, staticRenderFns } from "./PalletsRelease.vue?vue&type=template&id=a71d0cc6&scoped=true"
import script from "./PalletsRelease.vue?vue&type=script&lang=js"
export * from "./PalletsRelease.vue?vue&type=script&lang=js"
import style0 from "./PalletsRelease.vue?vue&type=style&index=0&id=a71d0cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71d0cc6",
  null
  
)

export default component.exports